module.exports = __webpack_public_path__ + "img/close-white.80257595.svg";